/********************************************
 * Accordion
 ********************************************/
function fnAccordion(i, oSection ) {

	var	oAccordions			= $( oSection );

	// On-click of accordion
	oAccordions.find( '> li.accordion .accordion-title' ).click( function() {

		$( this ).parent( 'li.accordion' ).addClass( 'current' );

		$( this ).parent( 'li.accordion' ).siblings( 'li.current' ).removeClass( 'current' );

		setTimeout(function () {
			$('html, body').animate({
				scrollTop: $(oAccordions).offset().top - 80
			}, 700);
		}, 500);

	} );

}
